import PageRenderer from "../components/PageRenderer";

const Datenschutz = () => <PageRenderer pageName="Datenschutz" analyticsPath="/datenschutz" />;

export default Datenschutz;
